
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppInput from '@/components/AppInput.vue'
import AppInputImage from '@/components/AppInputImage.vue'
import { integrationModuleEntity } from '@/models/models'
import { ChildComponentMixin } from '@/mixins'
import { ImageInterface, placeholderLogo, createImage } from '@/utils/image'
import { cloneDeep } from 'lodash'

@Component({
    components: {
        AppInput,
        AppInputImage,
    },
})

export default class IntegrationFormBasicData extends ChildComponentMixin {
    @Prop() public value?: IntegrationModuleEntity

    private logo: ImageInterface = placeholderLogo

    get integrationModule(): IntegrationModuleEntity {
        return this.value ?? integrationModuleEntity
    }

    get categoriesOptions(): InputSelectOptionEntity[] {
        const categories = cloneDeep(this.$store.state.integrationForm.modulecategories)

        const mappedCategories = categories.map((category: ModulecategoryEntity) => {
            return { value: category.id, text: category.name }
        })

        const emptyCategory = [{ value: '', text: '' }]
        const allCategories = emptyCategory.concat(mappedCategories)

        return allCategories
    }

    get userLogo(): string {
        return this.logo.imageURL === placeholderLogo.imageURL ? '' : this.logo.imageURL
    }

    @Watch('integrationModule')
    public onIntegrationModuleChange() {
        this.logo = createImage(this.integrationModule.logo, placeholderLogo)
    }

    public onLogoChanged(logo: ImageInterface) {
        this.$store.commit('integrationForm/setLogo', logo)
        this.logo = logo

        this.update(this.integrationModule, 'logo', this.userLogo)
    }
}
